import { LeftConferenceWaitingRoom } from 'domain/usecases/conferenceWaitingRoom/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteLeftConferenceWaitingRoom
  implements LeftConferenceWaitingRoom
{
  private readonly url: string;

  private readonly httpClient: HttpClient<LeftConferenceWaitingRoom.Model>;

  constructor(
    url: string,
    httClient: HttpClient<LeftConferenceWaitingRoom.Model>,
  ) {
    this.url = url;
    this.httpClient = httClient;
  }

  left = async (
    params: LeftConferenceWaitingRoom.Params,
  ): Promise<LeftConferenceWaitingRoom.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url.replace('{conferenceShort}', params.short),
      body: params.body,
      method: 'post',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
